var map = {
	"./antifraude.png": "83e1",
	"./cep_.png": "238f",
	"./cep_antifraude.png": "23b6",
	"./cep_controlinterno.png": "9647",
	"./cep_cumplimiento.png": "ec05",
	"./cep_industria.png": "f90f",
	"./cep_portaletico.png": "a83f",
	"./cep_prevencion.png": "fbc4",
	"./cep_regtech.png": "cd73",
	"./cep_regtechsuite.png": "fe3c",
	"./controlinterno.png": "74b6",
	"./cumplimiento.png": "84f3",
	"./industria.png": "7eec",
	"./portaletico.png": "215b",
	"./prevencion.png": "5dda"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d07d";